// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","MenuItem":"bgg_a bhm_vt bhm_ea bhm_a","MenuItem__Btn":"bgg_b bhm_z","MenuItem__subtitle":"bgg_c"};